const HorizontalPipe = () => {
  return <hr className=" border-gray-200 mt-5 mb-4 w-full" />;
};

export default HorizontalPipe;
